Array.from(
  document.querySelectorAll(
    ".cookie-consent-manage-btn, a[href$='#manage-cookie-settings']"
  )
).forEach((el) => {
  el.addEventListener("click", openCookieConsentSettings);
});

function openCookieConsentSettings() {
  //This only works for consentmo and with their current widget HTML markup
  const reopenWidgetEl = document.getElementById("reopen_widget");

  if (reopenWidgetEl && reopenWidgetEl.parentNode) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          // Check if the node is an element and is the next sibling of #reopen_widget
          if (
            node.nodeType === 1 &&
            reopenWidgetEl.nextElementSibling === node
          ) {
            const allBtns = node.querySelectorAll("button");
            allBtns[allBtns.length - 1].click();
            observer.disconnect(); // Stop observing once found
          }
        });
      });
    });
    // Observe the parent of #reopen_widget for child changes
    observer.observe(reopenWidgetEl.parentNode, { childList: true });
  }

  reopenWidgetEl.click();
}
